import restClient from 'api/restClient';
import { AxiosInstance, AxiosResponse } from 'axios';
import {
  AssessmentAnswer,
  AssessmentData,
  AssessmentQuestion,
  PaginatedResponse,
  UserAssessmentSummary,
} from 'backendTypes';

class AssessmentService {
  constructor(public readonly httpRequest: AxiosInstance) {}

  async getAssessment(): Promise<AssessmentData> {
    const { data } = await restClient(`/api/profile/intro_assessment/?new_version=True`, {
      method: 'GET',
    });
    return data;
  }

  async getAssessmentQuestion(questionId: number): Promise<AssessmentQuestion> {
    const { data } = await restClient(`api/profile/intro_assessment/question/${questionId}/`, {
      method: 'GET',
    });
    return data;
  }

  async postAssessmentAnswer(data: AssessmentAnswer): Promise<AxiosResponse> {
    const resp = await restClient('/api/assessment/answer/', {
      method: 'POST',
      data,
    });
    return resp;
  }

  async finishAssessment(): Promise<AxiosResponse> {
    const data = { completed: true };
    const resp = await restClient('/api/profile/intro_assessment/', {
      method: 'PATCH',
      data,
    });
    return resp;
  }

  async getUserAssessments(
    userId: string,
    page = 1,
    pageSize = 5
  ): Promise<PaginatedResponse<UserAssessmentSummary>> {
    const { data } = await restClient<PaginatedResponse<UserAssessmentSummary>>(
      '/api/assessment/user_assessment/',
      {
        method: 'GET',
        params: { eligibility_id: userId, page, page_size: pageSize },
      }
    );
    return data;
  }
}

export { AssessmentService };
